<ng-container *ngIf="lottieUrl">
  <lottie-player [src]="lottieUrl" background="transparent" speed="1" loop autoplay>
  </lottie-player>
</ng-container>